import { CREATE_ADD_HOME_PREF, CREATE_ADD_HOME_PREF_FAIL, CREATE_ADD_HOME_PREF_SUCCESS, CREATE_BUY_DESTINATION, CREATE_BUY_DESTINATION_FAIL, CREATE_BUY_DESTINATION_SUCCESS, CREATE_HOME_DESTINATION, CREATE_HOME_DESTINATION_FAIL, CREATE_HOME_DESTINATION_SUCCESS, CREATE_IMP_DESTINATION, CREATE_IMP_DESTINATION_FAIL, CREATE_IMP_DESTINATION_SUCCESS, DELETE_ADD_HOME_PREF, DELETE_ADD_HOME_PREF_FAIL, DELETE_ADD_HOME_PREF_SUCCESS, DELETE_HOME_DESTINATION, DELETE_HOME_DESTINATION_FAIL, DELETE_HOME_DESTINATION_SUCCESS, DELETE_IMP_DESTINATION, DELETE_IMP_DESTINATION_FAIL, DELETE_IMP_DESTINATION_SUCCESS, GET_ADD_HOME_PREF, GET_ADD_HOME_PREF_FAIL, GET_ADD_HOME_PREF_SUCCESS, GET_BUY_PREFRENCES_QUEST, GET_BUY_PREFRENCES_QUEST_FAIL, GET_BUY_PREFRENCES_QUEST_SUCCESS, GET_HOME_DESTINATION, GET_HOME_DESTINATION_FAIL, GET_HOME_DESTINATION_SUCCESS, GET_IMP_DESTINATION, GET_IMP_DESTINATION_FAIL, GET_IMP_DESTINATION_SUCCESS, UPDATE_ADD_HOME_PREF, UPDATE_ADD_HOME_PREF_FAIL, UPDATE_ADD_HOME_PREF_SUCCESS, UPDATE_HOME_DESTINATION, UPDATE_HOME_DESTINATION_FAIL, UPDATE_HOME_DESTINATION_SUCCESS, UPDATE_IMP_DESTINATION, UPDATE_IMP_DESTINATION_FAIL, UPDATE_IMP_DESTINATION_SUCCESS } from "./actionTypes"

export const getClientPrefrencesQuest = forType => (
  {
    type: GET_BUY_PREFRENCES_QUEST,
    forType,
  })

export const getClientPrefrencesQuestSuccess = questions => ({
  type: GET_BUY_PREFRENCES_QUEST_SUCCESS,
  payload: questions,
})

export const getClientPrefrencesQuestFail = error => ({
  type: GET_BUY_PREFRENCES_QUEST_FAIL,
  payload: error,
})


export const postBuyerDestination = (destination, history) => ({
  type: CREATE_BUY_DESTINATION,
  payload: { destination, history }
})

export const postBuyerDestinationSuccess = document => ({
  type: CREATE_BUY_DESTINATION_SUCCESS,
  payload: document
})

export const postBuyerDestinationFail = error => ({
  type: CREATE_BUY_DESTINATION_FAIL,
  payload: error
})


export const postHomePref = (homepref, callback) => ({
  type: CREATE_HOME_DESTINATION,
  payload: { homepref, callback }
})

export const postHomePrefSuccess = homepref => ({
  type: CREATE_HOME_DESTINATION_SUCCESS,
  payload: homepref
})

export const postHomePrefFail = error => ({
  type: CREATE_HOME_DESTINATION_FAIL,
  payload: error
})


export const getHomePref = ClientId => (
  {
    type: GET_HOME_DESTINATION,
    ClientId,
  })

export const getHomePrefSuccess = homeprefrences => ({
  type: GET_HOME_DESTINATION_SUCCESS,
  payload: homeprefrences,
})

export const getHomePrefFail = error => ({
  type: GET_HOME_DESTINATION_FAIL,
  payload: error,
})


export const updateHomePref = (homepref, callback) => (
  {

    type: UPDATE_HOME_DESTINATION,
    payload: {homepref,callback}
  })

export const updateHomePrefSuccess = homeprefrence => ({
  type: UPDATE_HOME_DESTINATION_SUCCESS,
  payload: homeprefrence,
})

export const updateHomePrefFail = error => ({
  type: UPDATE_HOME_DESTINATION_FAIL,
  payload: error,
})


export const deleteHomePref = id => ({
  type: DELETE_HOME_DESTINATION,
  payload: id,
})

export const deleteHomePrefSuccess = homeprefrence => ({
  type: DELETE_HOME_DESTINATION_SUCCESS,
  payload: homeprefrence,
})

export const deleteLeadStageFail = error => ({
  type: DELETE_HOME_DESTINATION_FAIL,
  payload: error,
})


export const postImpDestination = (impdes, callback) => ({
  type: CREATE_IMP_DESTINATION,
  payload: { impdes, callback }
})

export const postImpDestinationSuccess = impdes => ({
  type: CREATE_IMP_DESTINATION_SUCCESS,
  payload: impdes
})

export const postImpDestinationFail = error => ({
  type: CREATE_IMP_DESTINATION_FAIL,
  payload: error
})


export const getImpDestination = (agentId,clientId) => (
  {
    type: GET_IMP_DESTINATION,
    payload: { agentId, clientId }
  })

export const getImpDestinationSuccess = impdestinations => ({
  type: GET_IMP_DESTINATION_SUCCESS,
  payload: impdestinations,
})

export const getImpDestinationFail = error => ({
  type: GET_IMP_DESTINATION_FAIL,
  payload: error,
})



export const createAddHomePref = (addpref, history) => ({
  type: CREATE_ADD_HOME_PREF,
  payload: { addpref, history }
})

export const createAddHomePrefSuccess = addprefrence => ({
  type: CREATE_ADD_HOME_PREF_SUCCESS,
  payload: addprefrence
})

export const createAddHomePrefFail = error => ({
  type: CREATE_ADD_HOME_PREF_FAIL,
  payload: error
})


export const getAddHomePref = clientId => (
 
  {
    type: GET_ADD_HOME_PREF,
    clientId,
  })

export const getAddHomePrefSuccess = addprefrences => ({
  type: GET_ADD_HOME_PREF_SUCCESS,
  payload: addprefrences,
})

export const getAddHomePrefFail = error => ({
  type: GET_ADD_HOME_PREF_FAIL,
  payload: error,
})


export const updateAddHomePref = addpref => (
  {

    type: UPDATE_ADD_HOME_PREF,
    payload: addpref,
  })

export const updateAddHomePrefSuccess = addprefrence => ({
  type: UPDATE_ADD_HOME_PREF_SUCCESS,
  payload: addprefrence,
})

export const updateAddHomePrefFail = error => ({
  type: UPDATE_ADD_HOME_PREF_FAIL,
  payload: error,
})


export const deleteAddHomePref = id => ({
  type: DELETE_ADD_HOME_PREF,
  payload: id,
})

export const deleteAddHomePrefSuccess = addprefrence => ({
  type: DELETE_ADD_HOME_PREF_SUCCESS,
  payload: addprefrence,
})

export const deleteAddHomePrefFail = error => ({
  type: DELETE_ADD_HOME_PREF_FAIL,
  payload: error,
})


export const updateImpDestination = importantDes => (
  {

    type: UPDATE_IMP_DESTINATION,
    payload: importantDes,
  })

export const updateImpDestinationSuccess = impdestination => ({
  type: UPDATE_IMP_DESTINATION_SUCCESS,
  payload: impdestination,
})

export const updateImpDestinationFail = error => ({
  type: UPDATE_IMP_DESTINATION_FAIL,
  payload: error,
})


export const deleteImpDestination = id => ({
  type: DELETE_IMP_DESTINATION,
  payload: id,
})

export const deleteImpDestinationSuccess = impdestination => ({
  type: DELETE_IMP_DESTINATION_SUCCESS,
  payload: impdestination,
})

export const deleteImpDestinationFail = error => ({
  type: DELETE_IMP_DESTINATION_FAIL,
  payload: error,
})